export default __webpack_public_path__ + "static/Pala_1-6cd8483f7fd4d37b75f440e013536b7c.png";